module.exports = __webpack_public_path__ + "static/media/cover.0d7f0c8e.jpg";